/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {EXPAND_DIRECTIVES} from './index';
export class ClrIfExpandModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{imports: [CommonModule], declarations: [EXPAND_DIRECTIVES], exports: [EXPAND_DIRECTIVES]}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrIfExpandModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrIfExpandModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrIfExpandModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
